<script setup lang="ts">
/**
 * A checkbox of the application form with its sentence beside it (design prototype `bf-check`): a
 * native checkbox in the solid colour, 20 pixels, at the top of a sentence that may run over lines
 * and hold a link (the slot). A required one says so with an asterisk and `aria-required`, its
 * error stands below and is linked to it. Native rather than the pattern library's `PixCheckbox`,
 * whose headless parts do not pass this package's `exactOptionalPropertyTypes`.
 */
import { useId } from "vue";

const props = defineProps<{
  required?: boolean | undefined;
  error?: string | undefined;
}>();

const emit = defineEmits<{ blur: [] }>();

const model = defineModel<boolean>({ default: false });

const id = useId();
</script>

<template>
  <div class="flex flex-col gap-1">
    <label class="text-ui text-text-body flex cursor-pointer items-start gap-3">
      <input
        v-model="model"
        type="checkbox"
        class="accent-solid focus-visible:outline-focus mt-px size-5 flex-none cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2"
        :aria-required="props.required || undefined"
        :aria-invalid="props.error ? 'true' : undefined"
        :aria-describedby="props.error ? `${id}-error` : undefined"
        @blur="emit('blur')"
      />
      <span>
        <slot />
        <span v-if="props.required" class="text-bad-text font-extrabold" aria-hidden="true"> *</span>
      </span>
    </label>
    <span v-if="props.error" :id="`${id}-error`" role="alert" class="text-meta text-bad-text pl-8">{{
      props.error
    }}</span>
  </div>
</template>
